import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
export default defineComponent({
  name: "Attendance",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var tableData = ref([{}]);
    var _route$query = route.query,
        id = _route$query.id,
        title = _route$query.title;
    var pageIndex = ref(1);
    var totalNum = ref(0);
    var tab = ref([{}]);
    var punch = ref(null);

    function getMeetingAttendance() {
      return _getMeetingAttendance.apply(this, arguments);
    }

    function _getMeetingAttendance() {
      _getMeetingAttendance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingAttendPerson"]({
                  offlineMeetingId: id
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;

                if (punch.value == 1) {
                  tableData.value = data.registeredList;
                  tab.value = data.registeredList;
                  totalNum.value = data.registeredList.length;
                } else if (punch.value == 3) {
                  tableData.value = data.lateList;
                  tab.value = data.lateList;
                  totalNum.value = data.lateList.length;
                } else if (punch.value == 4) {
                  tableData.value = data.leaveList;
                  tab.value = data.leaveList;
                  totalNum.value = data.leaveList.length;
                } else if (punch.value == 5) {
                  tableData.value = data.not_join_list;
                  tab.value = data.not_join_list;
                  totalNum.value = data.not_join_list.length;
                }

                pge(1);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getMeetingAttendance.apply(this, arguments);
    }

    function getMeetingAttendanceAll(_x) {
      return _getMeetingAttendanceAll.apply(this, arguments);
    }

    function _getMeetingAttendanceAll() {
      _getMeetingAttendanceAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
        var _yield$globalProperti2, data, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMeetingAttendPersonList"]({
                  offlineMeetingId: id,
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  punch: res
                });

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                tableData.value = data;
                totalNum.value = total;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getMeetingAttendanceAll.apply(this, arguments);
    }

    function pge(num) {
      var as = num * 10;
      tableData.value = [];

      if (tab.value.length - 1 < num * 10) {
        as = tab.value.length;
      }

      for (var i = (num - 1) * 10; i < as; i++) {
        tableData.value[i] = tab.value[i];
      }
    }

    function changPage(val) {
      pageIndex.value = val;
      getMeetingAttendanceAll(punch.value); // pge(val);
    }

    if (title == "签到") {
      punch.value = 1;
      getMeetingAttendanceAll(1);
    } else if (title == "迟到") {
      punch.value = 3;
      getMeetingAttendanceAll(3);
    } else if (title == "请假") {
      punch.value = 4;
      getMeetingAttendanceAll(4);
    } else if (title == "旷会") {
      punch.value = 5;
      getMeetingAttendanceAll(5);
    } else if (title == "全部人数") {
      punch.value = null;
      getMeetingAttendanceAll(null);
    }

    return {
      getMeetingAttendance: getMeetingAttendance,
      getMeetingAttendanceAll: getMeetingAttendanceAll,
      tableData: tableData,
      pageIndex: pageIndex,
      totalNum: totalNum,
      changPage: changPage,
      punch: punch,
      pge: pge,
      tab: tab
    };
  }
});